/* RESPONSIBLE TEAM: team-standalone */
import Model, { attr } from '@ember-data/model';
import { IntegrationType } from 'embercom/objects/standalone/constants';
import type Integration from 'embercom/models/standalone/integration';
import type SalesforceConfiguration from 'embercom/models/standalone/salesforce-configuration';

export default class Environment extends Model {
  @attr('number') declare integrationId: number;
  @attr('number') declare integrationType: IntegrationType;
  @attr('string') declare integrationIdentifier: string;
  @attr('boolean') declare defaultIntegration: boolean;

  get integration(): Integration {
    return this.store.peekRecord(
      'standalone/integration',
      `${this.integrationType}-${this.integrationId}`,
    );
  }

  get label(): string {
    if (this.salesforceConfiguration) {
      return `${this.salesforceConfiguration.environmentLabel} - ${this.salesforceConfiguration.domain}`;
    }
    return this.integration.externalIdentifier;
  }

  get salesforceConfiguration(): SalesforceConfiguration | null {
    if (this.integrationType !== IntegrationType.SalesforceCases) {
      return null;
    }

    return this.store.peekRecord('standalone/salesforce-configuration', this.integrationId);
  }
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'environments/environment': Environment;
  }
}
